// extracted by mini-css-extract-plugin
module.exports = {"icon":"e_1w","container":"e_2w","overlay":"e_3w"};